import React, { useEffect, useState } from "react";
import { ButtonBase, Stack, Box, Paper, Fade } from "@mui/material";
import { SyvaLogo } from "Components/syva-logo/syva-logo";
import Messenger from "Components/Chat/_gears/Messenger";
import { useDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";
import { DndContext, useSensors, useSensor, PointerSensor } from "@dnd-kit/core";
import { DOMAIN } from "config/config";
import { DATA_LINK } from "connectors";
import { store } from "static";
import axios from "axios";
import { HStack, VStack } from "Components";
import "./messenger-with-avatar.scss";
import { HtmlParserWrapper } from "Components/HtmlParserWrapper";
import { AvailLANG } from "typings";

interface AvatarProps {
  position: { bottom: number; right: number };
  holding: boolean;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}
interface DisclaimerProps {
  SC: string;
  EN: string;
  TC: string;
}

const Avatar = ({ position, holding, onClick }: AvatarProps) => {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: "messengerDraggable",
  });

  const style = {
    transform: CSS.Translate.toString(transform),
  };

  const sx = {
    position: "fixed",
    zIndex: 10,
    bottom: position.bottom,
    right: position.right,
  };

  return (
    <Stack ref={setNodeRef} style={style} {...listeners} {...attributes} sx={sx}>
      <ButtonBase
        sx={{
          boxShadow: holding ? "10" : "2",
          height: 70,
          width: 70,
          borderRadius: "50%",
          backgroundColor: "white",
        }}
        onClick={onClick}
      >
        <SyvaLogo />
      </ButtonBase>
    </Stack>
  );
};

export const MessengerWithAvatar = () => {
  const [chatWindow, setChatWindow] = useState(false);
  const [position, setPosition] = useState({ bottom: 70, right: 20 });
  const [holding, setHolding] = useState(false);

  const [showDisclaimer, setShowDisclaimer] = useState(true);
  const [showMessenger, setShowMessenger] = useState(false);
  const [disclaimer, setDisclaimer] = useState<DisclaimerProps | null>(null);

  useEffect(() => {
    fetchDisclaimers().then((res) => {
      setDisclaimer(res);
    });
  }, []);

  const fetchDisclaimers = async () => {
    const response = await axios.post(`${DOMAIN}${DATA_LINK.GetDisclaimer}`, { JWT: store.user.JWT });
    console.log(response.data?.payload?.Content);
    return response.data?.payload?.Content;
  };

  const handleDragStart = (_e: any) => {
    setHolding(true);
  };

  const handleDragEnd = (event: any) => {
    setPosition((prevPos) => ({
      right: prevPos.right - event.delta.x,
      bottom: prevPos.bottom - event.delta.y,
    }));
    setHolding(false);
  };

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        delay: 200,
        tolerance: 10,
      },
    })
  );
  const handleAgree = () => {
    setShowDisclaimer(false);
    setShowMessenger(true);
  };

  const handleExit = () => {
    setChatWindow(false);
  };

  function renderHeader() {
    return (
      <Box className="headline" sx={{ width: "100%", display: "flex" }}>
        <Box className="left">
          <div className={"syva_logo"}></div>
        </Box>

        <div className="text">{"Talk2VA"}</div>

        <Box className="right"></Box>
      </Box>
    );
  }

  const DisclaimerBox = () => {
    return (
      <VStack sx={{ height: "100%", justifyContent: "flex-start" }}>
        {renderHeader()}

        <div className="disclaimer-box">
          <h3 className="disclaimer-title">Disclaimer</h3>
          <Box className="disclaimer-message">{<HtmlParserWrapper html={"<div>" + (disclaimer?.[(store.urlParams?.lang ?? "EN") as AvailLANG] ?? "") + "</div>"} />}</Box>
          <HStack>
            <button className="disclaimer-btn" onClick={handleAgree}>
              Agree
            </button>
            {/* <button className="disclaimer-btn" onClick={handleExit}>
              Exit
            </button> */}
          </HStack>
        </div>
      </VStack>
    );
  };

  return (
    <DndContext onDragStart={handleDragStart} onDragEnd={handleDragEnd} sensors={sensors}>
      {chatWindow && (
        <Fade in={chatWindow} timeout={500}>
          <Box sx={{ height: 600, width: 400, position: "fixed", bottom: 100, right: 100, zIndex: 10 }}>
            <Paper sx={{ width: "100%", height: "100%", pb: 1 }}>
              {showDisclaimer && disclaimer && <DisclaimerBox />}
              {showMessenger && <Messenger name={"Talk2VA"} LiveChatEnabled={true} viaBackend={false} />}
              {/* <Messenger name={"SYVA GPT-QA"} project={"All"} LiveChatEnabled={false} viaBackend={true} url={`${DOMAIN}${DATA_LINK.DMTalk2GPT}`} /> */}
            </Paper>
          </Box>
        </Fade>
      )}

      <Avatar
        position={position}
        holding={holding}
        onClick={() => {
          setChatWindow(!chatWindow);
        }}
      />
    </DndContext>
  );
};
